"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxColorThemes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var BoxColorThemes;
(function (BoxColorThemes) {
    BoxColorThemes["default"] = "default";
    BoxColorThemes["white"] = "white";
})(BoxColorThemes = exports.BoxColorThemes || (exports.BoxColorThemes = {}));
var BoxContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 2.4rem;\n  border: ", ";\n  border-color: ", ";\n"], ["\n  background-color: ", ";\n  padding: 2.4rem;\n  border: ", ";\n  border-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme) {
        case BoxColorThemes.white:
            return b2c_theme_1.colors.white;
        default:
            return b2c_theme_1.colors.box.defaultBackgroundColor;
    }
}, function (_a) {
    var bordered = _a.bordered;
    return bordered ? '1px solid' : 'none';
}, function (_a) {
    var bordered = _a.bordered, theme = _a.theme;
    if (bordered) {
        switch (theme) {
            case BoxColorThemes.white:
                return b2c_theme_1.colors.box.whiteThemeBorderColor;
            default:
                return b2c_theme_1.colors.box.defaultBorderColor;
        }
    }
    return 'transparent';
});
var Box = function (_a) {
    var bordered = _a.bordered, children = _a.children, theme = _a.theme, rest = __rest(_a, ["bordered", "children", "theme"]);
    return (react_1.default.createElement(BoxContainer, __assign({ "data-testid": "box-container", bordered: bordered, theme: theme }, rest), children));
};
exports.default = Box;
var templateObject_1;
//# sourceMappingURL=Box.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Box/Box.js
// module id = 1493
// module chunks = 1 5 14 16 19 40